import { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Badge } from "@/components/ui/badge";
import { Card } from "@/components/ui/card";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { API } from "./Sidebar";

export const WebsitesPage = () => {
  const [websites, setWebsites] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchWebsites = async () => {
      try {
        const res = await axios.get(`${API}/websites`);
        setWebsites(res.data);
      } catch (e) {
        toast.error("Failed to load websites");
      } finally {
        setLoading(false);
      }
    };
    fetchWebsites();
  }, []);

  return (
    <div data-testid="websites-page">
      <div className="mb-8">
        <h2 className="text-2xl font-bold text-slate-900" style={{ fontFamily: "var(--font-heading)" }}>
          Deployed Websites
        </h2>
        <p className="text-slate-600 mt-1">Manage your live lead generation websites</p>
      </div>

      <Card>
        <Table>
          <TableHeader>
            <TableRow className="bg-slate-50">
              <TableHead>Company</TableHead>
              <TableHead>Domain</TableHead>
              <TableHead>Location</TableHead>
              <TableHead>Leads</TableHead>
              <TableHead>Status</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={5} className="text-center py-8 text-slate-500">Loading...</TableCell>
              </TableRow>
            ) : websites.length === 0 ? (
              <TableRow>
                <TableCell colSpan={5} className="text-center py-8 text-slate-500">No websites found</TableCell>
              </TableRow>
            ) : (
              websites.map((website) => (
                <TableRow key={website.id}>
                  <TableCell className="font-medium">{website.company_name}</TableCell>
                  <TableCell>{website.domain}</TableCell>
                  <TableCell>{website.city}, {website.state}</TableCell>
                  <TableCell>{website.lead_count}</TableCell>
                  <TableCell>
                    <Badge className={website.is_active ? "bg-green-100 text-green-700" : ""}>
                      {website.is_active ? "Active" : "Inactive"}
                    </Badge>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </Card>
    </div>
  );
};
